// extracted by mini-css-extract-plugin
export default {"Checkbox":"suggested-item-module__Checkbox--vEU1Y"};